<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资料管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加资料</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图 -->
    <el-card>

      <!-- 资料添加表单 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="150px" style="width: 1000px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="addForm.description" placeholder="请输入描述"></el-input>
        </el-form-item>

        <el-row :gutter="2">
          <el-col :span="8">
            <el-form-item label="文件大小" prop="file_size">
              <el-input v-model="addForm.file_size" placeholder="例如：12MB 或 120KB"></el-input>
            </el-form-item>

          </el-col>
          <el-col :span="8">
            <el-form-item label="总页数" prop="total_page">
              <el-input v-model.number="addForm.total_page" type="number" min="0" placeholder="例如：12"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="价格" prop="price">
              <el-input v-model.number="addForm.price" type="number" min="0" placeholder="单位：元"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="1">
          <el-col :span="8">
            <el-form-item label="年级" prop="grade_id">
              <el-select v-model="addForm.grade_id" placeholder="请选择年级">
                <el-option v-for="item in gradeOptions" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学科" prop="subject_id">
              <el-select v-model="addForm.subject_id" placeholder="请选择学科">
                <el-option v-for="item in subjectOptions" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分类" prop="category_id">
              <el-select v-model="addForm.category_id" placeholder="请选择分类">
                <el-option v-for="item in categoryOptions" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="文件类型" prop="file_type">
              <el-select v-model="addForm.file_type" placeholder="请选择类型">
                <el-option v-for="item in fileTypeOptions" :key="item.id" :label="item.label" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="下载是否需要会员" prop="isVip">
              <el-switch v-model="addForm.isVip" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="是否上架" prop="status">
              <el-switch v-model="addForm.status" :active-value="1" :inactive-value="0" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="角标" prop="mark">
              <el-input v-model="addForm.mark" placeholder="可选，如精品"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="2">

          <el-col :span="6">
            <el-form-item label="标识" prop="identification">
              <el-input v-model="addForm.identification" placeholder="可选，如：广州市增城区"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item label="点击数" prop="click_count">
              <el-input v-model.number="addForm.click_count" type="number" min="0" placeholder="可选，如：12345"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item label="下载数" prop="download_count">
              <el-input v-model.number="addForm.download_count" type="number" min="0" placeholder="可选，如：12345"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item label="收藏数" prop="collection_count">
              <el-input v-model.number="addForm.collection_count" type="number" min="0" placeholder="可选，如：12345"></el-input>
            </el-form-item>
          </el-col>

        </el-row>



        <el-form-item label="下载链接" prop="download_url">
          <el-input v-model="addForm.download_url" placeholder="http(s)://"></el-input>
        </el-form-item>
        <el-form-item label="封面图" prop="fengmian_url">
          <el-upload :action="uploadURL" :headers="headerObj" list-type="picture" :limit="1"
            :file-list="fengmianFileList" :on-success="handleCoverSuccess" :on-remove="handleCoverRemove" name="images">
            <el-button size="small" type="primary">上传封面图（最多1张）</el-button>
          </el-upload>
        </el-form-item>


        <el-form-item label="详情内容" prop="content">
          <quill-editor v-model="addForm.content" :options="editorOption" ref="myQuillEditor"></quill-editor>
          <input id="ziliao-quill-image-input" ref="quillImageInput" type="file" multiple accept="image/*" style="display:none"
            @change="handleQuillImageChange" />
        </el-form-item>
      </el-form>
    </el-card>
    <div class="floating-actions">
      <el-button type="default" class="btnBack" @click="goBack">返回</el-button>
      <el-button type="primary" class="btnAdd" @click="submitForm">{{ isEditMode ? '更新资料' : '添加资料' }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //图片上传地址
      uploadURL: 'https://jxpyq666.com/common/uploads',
      // 资料添加的表单数据对象
      addForm: {
        id: 0,
        name: '',
        category_id: null,
        grade_id: null,
        subject_id: null,
        isVip: 0,
        price: 0,
        mark: '',
        identification: '',
        download_url: '',
        fengmian_url: '',
        file_size: '',
        file_type: 0,
        total_page: 0,
        click_count: 0,
        download_count: 0,
        collection_count: 0,
        description: '',
        status: 0,
        content: ''
      },
      // 表单校验规则
      addFormRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        category_id: [{ required: true, message: '请选择分类', trigger: 'change' }],
        grade_id: [{ required: true, message: '请选择年级', trigger: 'change' }],
        subject_id: [{ required: true, message: '请选择学科', trigger: 'change' }], 
        content: [{ required: true, message: '请输入详情内容', trigger: 'blur' }]
      },
      editorOption: {
        placeholder: '请输入内容',
        theme: 'snow',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ['link', 'image'],
              ['clean']
            ],
            handlers: {
              image: function (value) {
                if (value) {
                  const input = document.getElementById('ziliao-quill-image-input')
                  if (input) input.click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          }
        }
      },
      // 选项
      categoryOptions: [],
      gradeOptions: [],
      subjectOptions: [],

      fileTypeOptions: [
        { id: 0, label: 'pdf' },
        { id: 1, label: 'word' },
        { id: 2, label: 'excel' },
        { id: 3, label: '图片' },
        { id: 4, label: '其他' }
      ],
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      fengmianFileList: []
      ,
      // 编辑模式下的查询ID
      queryId: null
    }
  },
  computed: {
    isEditMode() {
      return !!this.queryId
    }
  },

  created() {
    const qid = this.$route && this.$route.query && this.$route.query.id
    this.queryId = qid ? Number(qid) : null
    if (this.queryId) {
      this.getDetail()
    }
    this.getCategoryList()
    this.getGradeList()
    this.getSubjectList()
  },

  methods: {
     // 年级列表
    async getGradeList() {
      const { data: res } = await this.$http.get('admin/g/activeList', {})
      if (res.code !== 200) {
        return this.$message.error('获取年级列表失败！')
      }
      this.gradeOptions = res.result.map(item => ({
        id: item.id,
        label: item.name
      }))
    },
   
    // 学科列表
    async getSubjectList() {
      const { data: res } = await this.$http.get('admin/s/activeList', {})
      if (res.code !== 200) {
        return this.$message.error('获取学科列表失败！')
      }
      this.subjectOptions = res.result.map(item => ({
        id: item.id,
        label: item.name
      }))
    },
    goBack() {
      this.$router.back()
    },

     // 分类列表
    async getCategoryList() {
      const { data: res } = await this.$http.get('admin/c/activeList', {})
      if (res.code !== 200) {
        return this.$message.error('获取分类列表失败！')
      }
      this.categoryOptions = res.result.map(item => ({
        id: item.id,
        label: item.name
      }))
    },


    // 根据id获取资料详情并填充表单
    async getDetail() {
      try {
        const { data: res } = await this.$http.get('admin/m/detail', {
          params: { id: this.queryId }
        })
        if (res.code !== 200) {
          return this.$message.error('获取资料详情失败！')
        }
        const detail = res.result || {}
        this.addForm = detail
        // 设置封面初始预览
        if (detail.fengmian_url) {
          this.fengmianFileList = [{ name: '封面', url: detail.fengmian_url }]
        } else {
          this.fengmianFileList = []
        }
        this.$message.success('获取资料详情成功！')
      } catch (e) {
        console.log(e)
        this.$message.error('获取资料详情异常！')
      }
    },



    // 提交资料
    add() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        // 调用后端接口提交表单
        const form = this.addForm
        const { data: res } = await this.$http.post('admin/m/add', form)
        if (res.code !== 200) {
          return this.$message.error('添加资料失败！')
        }
        this.$message.success('添加资料成功！')
        this.$router.push('/goods')
      })
    },

    // 提交/更新资料（根据是否编辑模式）
    submitForm() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        const form = this.addForm
        try {
          let res
          if (this.isEditMode) {
            ({ data: res } = await this.$http.post('admin/m/update', form))
            if (res.code !== 200) return this.$message.error('更新资料失败！')
            this.$message.success('更新资料成功！')
          } else {
            ({ data: res } = await this.$http.post('admin/m/add', form))
            if (res.code !== 200) return this.$message.error('添加资料失败！')
            this.$message.success('添加资料成功！')
          }
          this.$router.push('/goods')
        } catch (e) {
          console.log(e)
          this.$message.error(this.isEditMode ? '更新资料异常！' : '添加资料异常！')
        }
      })
    },

    // 封面上传成功
    handleCoverSuccess(response, file, fileList) {
      if (response && response.code === 200) {
        this.addForm.fengmian_url = response.result && (response.result.show || response.result.url || response.result.path)
        this.fengmianFileList = [{ name: file.name, url: this.addForm.fengmian_url }]
      } else {
        this.$message.error('封面上传失败！')
      }
    },
    // 封面移除
    handleCoverRemove() {
      this.addForm.fengmian_url = ''
      this.fengmianFileList = []
    },
    async handleQuillImageChange(e) {
      const files = Array.from(e.target.files || [])
      if (!files.length) return
      let successCount = 0
      for (const file of files) {
        try {
          const url = await this.uploadImageToServer(file)
          this.insertImageToEditor(url)
          successCount++
        } catch (err) {
          console.log(err)
        }
      }
      if (successCount > 0) {
        this.$message.success(`已上传并插入${successCount}张图片！`)
      } else {
        this.$message.error('图片上传失败！')
      }
      e.target.value = ''
    },
    async uploadImageToServer(file) {
      const fd = new FormData()
      fd.append('images', file)
      const token = window.sessionStorage.getItem('token')
      const resp = await fetch(this.uploadURL, {
        method: 'POST',
        headers: {
          Authorization: token || ''
        },
        body: fd
      })
      const data = await resp.json()
      if (!data || data.code !== 200) {
        throw new Error('upload failed')
      }
      return data.result && (data.result.show || data.result.url || data.result.path)
    },
    insertImageToEditor(imageUrl) {
      if (!imageUrl) throw new Error('empty image url')
      try {
        const quill = this.$refs.myQuillEditor.quill
        const selection = quill.getSelection()
        const index = selection ? selection.index : quill.getLength()
        quill.insertEmbed(index, 'image', imageUrl)
        quill.setSelection(index + 1)
        this.addForm.content = quill.root.innerHTML
      } catch (e) {
        console.log(e)
        this.$message.error('图片插入失败！')
      }
    }
  }
}
</script>

<style scoped>
.btnAdd {
  margin-top: 20px;
}

.floating-actions {
  position: fixed;
  right: 32px;
  bottom: 32px;
  display: flex;
  gap: 12px;
  z-index: 1000;
}

.btnBack {
  background: #fff;
  color: #606266;
  border: 1px solid #dcdfe6;
}

.btnBack:hover {
  color: #409eff;
  border-color: #c6e2ff;
}
</style>
